define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/store/Memory"
], function(array,declare,Memory) {

	// Augment Memory store to support ordering - reference dgrid demos

	var	calculateOrder = function(store, current, before, idOrder) {
		// Calculates proper value of order for an item to be placed before another
		
		// NOTE: make sure to pass options or else sort will not apply (think it has
		// something to do with Observable store wrapper) 
		var results = store.query(null, {});

		// find maximum order and place this one after it
		if (!before) {
			var	last = results.pop();
			current[idOrder] = (last ? last[idOrder] : 0) + 1;
			return;
		}

		// doesn't make sense for move an object before itself
		if (before === current) return;
		
		var	beforeOrder = before[idOrder];
		var	n = array.indexOf(results, before);
		if (!n) {
			// subtract 1 from earliest order
			current[idOrder] = beforeOrder - 1;
			return;			
		}
		
		// nothing to do if current is already 1 before "before"
		var	oneBefore = results[n-1];
		if (current === oneBefore) return;
		
		var	currentOrder = current[idOrder];
		
		if (current === results[n+1]) {
			// moving up 1, so just swap orders
			current[idOrder] = beforeOrder;
			before[idOrder] = currentOrder;
		} else if (current === results[n-2]) {
			// moving down 1, so just swap orders
			current[idOrder] = oneBefore[idOrder];
			oneBefore[idOrder] = currentOrder;
		} else {
			// midpoint of previous orders
			current[idOrder] = (beforeOrder + oneBefore[idOrder]) / 2;
		}
	};
	
	return declare(Memory, {
		// String: id of attribute designating order
		idOrder: "__ORDER__",
		 
		put: function(object, options){
			// calculate order if options.before is provided or this item doesn't have any order
			options = options || {};
			
			if (options.before !== undefined || (object[this.idOrder] == null)) {
				calculateOrder(this, object, options.before, this.idOrder);
			}
			
			return this.inherited(arguments); 
		},
		
		query: function(query, options) {
			// sort by order field
			options = options || {};
			options.sort = options.sort || [{attribute: this.idOrder}];
			return this.inherited(arguments, [query, options]);
		},
		
		setData: function(data) {
			// populate order if not already provided
			var	n = data.length;
			if (n) {
				var	idOrder = this.idOrder;
				var	id = this.idProperty;
				var	i;
				
				if (data[0][idOrder] === undefined) {
					for (i = 0; i < n; ++i) {
						data[i][idOrder] = i+1;
					}
				}
	
				if (data[0][id] === undefined) {
					for (i = 0; i < n; ++i) {
						data[i][id] = i+1;
					}
				}
			}
			
			this.inherited(arguments);
		}
	});
});
